import React, { forwardRef, useImperativeHandle } from "react"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import DynamicFormField from "./DynamicFormField"
import { autoFillData } from "@common/FunctionList"
import { useNavigate } from "react-router"

const VehicleDetails = forwardRef((props: any, ref) => {
    const [sectionItem, setSectionItem] = useState<any>({})
    const insuranceState = useSelector((state: any) => state.insurance)

    const navigate = useNavigate()

    const autoFillVehicleDetails = async (insuranceData: any) => {
        const updatedData = await autoFillData(insuranceData, insuranceState?.formConfig?.[1])
        setSectionItem(updatedData)
        // props.setSectionList(updatedData);
    }

    useImperativeHandle(ref, () => ({
        getData: () => {
            return { vehicle_details: [...sectionItem?.blocks?.[0]?.fields], customer_details: [...sectionItem?.blocks?.[1]?.fields] }
        }
    }))

    useEffect(() => {
        if (insuranceState?.formConfig?.length) {
            let sectionItem = JSON.parse(JSON.stringify(insuranceState?.formConfig?.[1]));

            let updatedSectionItem = {
                ...sectionItem,
                blocks: sectionItem.blocks.map((block: any) => ({
                    ...block,
                    fields: block.fields.map((field: any) =>
                        ["effectivity_date", "expiry_date"].includes(field.name) && field.value !== ""
                            ? { ...field, value: new Date(field.value) }
                            : field
                    )
                }))
            };

            setSectionItem(updatedSectionItem);
            // setSectionItem(JSON.parse(JSON.stringify(insuranceState?.formConfig?.[1])))
        }
        //eslint-disable-next-line
    }, [insuranceState.formConfig])

    useEffect(() => {
        let insuranceData = props?.resubmissionLeadId ? insuranceState.resubmissionLeadData : insuranceState?.insuranceData

        if (insuranceState?.formConfig?.[1]?.blocks?.length) {
            if (insuranceData && Object.keys(insuranceData)?.length && !insuranceData?.autoFillVehicleDetails) {
                autoFillVehicleDetails(insuranceData)
            } else if (!(insuranceData && Object.keys(insuranceData)?.length)) {
                // autoFillData({}, true)
            }
        }
        // eslint-disable-next-line
    }, [insuranceState.insuranceData, insuranceState?.formConfig, insuranceState?.resubmissionLeadData])

    useEffect(() => {
        if (!(props?.documents && Object.keys(props?.documents)?.length) && !props?.resubmissionLeadId) {
            props?.setPage(1)
            navigate('/create-insurance-policy?step=upload_document')
        }
        //eslint-disable-next-line
    }, [props?.documents])

    return (
        <div className="loan-filed-sec">
            <div className="form-group-bx vehchile-detail-form">
                <div className="row">
                    {
                        sectionItem?.blocks?.map((blockItem: any, index: number) =>
                            <React.Fragment key={index}>
                                <div className="col-md-12 col-xs-12">
                                    <div className="summery-heading">
                                        <h2>{blockItem.title}</h2>
                                    </div>
                                </div>
                                <DynamicFormField
                                    fields={blockItem?.fields}
                                    stateCityList={props.stateCityList}
                                    fetchCustomerData={() => { }}
                                    setLoading={props.setLoading}
                                    SetUpdateMakeYear={props.SetUpdateMakeYear}
                                />
                            </React.Fragment>
                        )
                    }

                </div>
            </div>
        </div>
    )
})

export default VehicleDetails
